import useSWRImmutable from 'swr/immutable';

import { universalFiltersConfig } from 'MODULES/universal-filters/useUniversalFilters/universalFiltersConfig';
import { toast } from 'SRC/components/Toast';
import {
  fetchFilters,
  OBSERVABILITY_FILTERS,
} from 'SRC/fetch/api/observability';
import { useIdentity } from 'SRC/hooks/useIdentity';
import { isTest } from 'UTILS/env';

export function useFetchFilters() {
  const { user } = useIdentity();
  const setFilters = universalFiltersConfig((state) => state.setFilters);

  const { isLoading, error } = useSWRImmutable(
    isTest() || user ? OBSERVABILITY_FILTERS : null,
    fetchFilters,
    {
      onError: () => {
        toast.negative({ description: 'Failed to load filters' });
      },
      onSuccess: (data) => {
        setFilters(data);
      },
    },
  );

  return {
    isLoading,
    error,
  };
}
